<aside class="app-sidebar" [class.collapsed]="collapsed()" [class.mobile-open]="mobileOpen()">
  <div class="sidebar-heading"><span class="sidebar-section-label">MAIN MENU</span><button class="sidebar-close" type="button" aria-label="Close navigation" (click)="closeMobile.emit()"><i class="pi pi-times"></i></button></div>
  <nav class="sidebar-nav" aria-label="Primary navigation">
    <ng-container *ngFor="let item of menuItems">
      <a
        *ngIf="!hasChildren(item); else parentMenu"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
        [routerLink]="item.route"
        [title]="collapsed() ? item.label : ''"
        (click)="closeOnNavigate()"
      >
        <i class="pi" [ngClass]="item.icon"></i>
        <span>{{ item.label }}</span>
      </a>

      <ng-template #parentMenu>
        <button
          type="button"
          class="nav-item nav-parent"
          [class.active]="isParentActive(item)"
          [class.expanded]="isExpanded(item)"
          [title]="collapsed() ? item.label : ''"
          (click)="toggleMenu(item)"
        >
          <i class="pi" [ngClass]="item.icon"></i>
          <span>{{ item.label }}</span>
          <i class="pi pi-chevron-down parent-toggle"></i>
        </button>

        <div class="submenu" [class.open]="isExpanded(item)">
          <a
            *ngFor="let child of item.children"
            class="nav-item submenu-item"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: child.exact ?? false }"
            [routerLink]="child.route"
            [title]="collapsed() ? child.label : ''"
            (click)="closeOnNavigate()"
          >
            <i class="pi" [ngClass]="child.icon"></i>
            <span>{{ child.label }}</span>
          </a>
        </div>
      </ng-template>
    </ng-container>
  </nav>
  <div class="sidebar-footer"><div class="secure-badge"><i class="pi pi-shield"></i><span>Secure enterprise environment</span></div><small>ABT Energy Accounting Software</small></div>
</aside>
